export type StatusColorsKeys =
  | "VU scheduled"
  | "VU creation in progress"
  | "VU waiting to merge"
  | "VU merge in progress"
  | "Waiting to export"
  | "Export in progress"
  | "Export in queue"
  | "Exports in queue"
  | "Exports in progress"
  | "Exports need attention"
  | "Export complete"
  | "Exports complete"
  | "Waiting to ship"
  | "Shipping in progress"
  | "Successfully shipped"
  | "Canceled at export"
  | "Failed at export"
  | "Failed at shipping"
  | "Shipping needs attention"
  | "Checksum required"
  | "Checksum in progress"
  | "Failed at checksum"
  | "Checksum needs attention"
  | "Not started";

export const shipmentLevelStatuses: StatusColorsKeys[] = [
  "VU scheduled",
  "VU creation in progress",
  "VU waiting to merge",
  "Waiting to export",
  "Export in queue",
  "Export in progress",
  "Export complete",
  "Waiting to ship",
  "Shipping in progress",
  "Checksum required",
  "Successfully shipped",
  "Canceled at export",
  "Failed at export",
  "Failed at shipping",
  "Failed at checksum",
  "Not started",
];

export const customerLevelStatuses: StatusColorsKeys[] = [
  "VU creation in progress",
  "Exports in progress",
  "Exports need attention",
  "Checksum needs attention",
  "Checksum required",
  "Checksum in progress",
  "Shipping needs attention",
];

export const status_colors: Record<StatusColorsKeys, string> = {
  "VU scheduled": "#CF8BE0",
  "VU creation in progress": "#9258D0",
  "VU waiting to merge": "#6A5ACD",
  "VU merge in progress": "#3B316D",
  "Waiting to export": "#A3D8F4",
  "Export in queue": "#5FB3F3",
  "Exports in queue": "#5FB3F3",
  "Export in progress": "#3790D7",
  "Exports in progress": "#3790D7",
  "Exports need attention": "#D87A1D",
  "Export complete": "#357ABD",
  "Exports complete": "#357ABD",
  "Waiting to ship": "#1C3E72",
  "Shipping in progress": "#43e8d8",
  "Successfully shipped": "#2E8B57",
  "Canceled at export": "#F2A541",
  "Failed at export": "#D87A1D",
  "Failed at shipping": "#E74C3C",
  "Shipping needs attention": "#E74C3C",
  "Failed at checksum": "#E74C3C",
  "Checksum needs attention": "#E74C3C",
  "Checksum required": "#00cc9c",
  "Checksum in progress": "#009293",
  "Not started": "#7D7D7D",
};
